<template>
  <div v-if="visible" class="format-modal-overlay">
    <div class="format-modal">
      <div class="modal-header">
        <h3>規格管理 - {{ initialData?.productName }}</h3>
        <button class="close-btn" @click="handleClose">×</button>
      </div>

      <div class="modal-body">
        <!-- 規格類型選擇 -->
        <div class="spec-type-selector">
          <label class="radio-option">
            <input
              type="radio"
              value="single"
              v-model="specType"
              @change="handleSpecTypeChange"
            />
            <span>單一規格</span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              value="multiple"
              v-model="specType"
              @change="handleSpecTypeChange"
            />
            <span>多規格</span>
          </label>
        </div>

        <!-- 單一規格 -->
        <div v-if="specType === 'single'" class="single-spec-section"></div>

        <!-- 多規格 -->
        <div v-if="specType === 'multiple'" class="multiple-spec-section">
          <div class="toolbar">
            <button class="add-spec-btn" @click="addSpecification">
              + 新增規格
            </button>
            <button
              v-if="selectedSpecs.length > 0"
              class="batch-delete-btn"
              @click="batchDeleteSpecifications"
            >
              刪除已選 ({{ selectedSpecs.length }})
            </button>
          </div>

          <div class="spec-list">
            <div
              v-for="(spec, index) in specifications"
              :key="index"
              class="spec-item"
              :class="{ selected: selectedSpecs.includes(index) }"
            >
              <div class="spec-header">
                <div class="spec-header-left">
                  <input
                    type="checkbox"
                    :checked="selectedSpecs.includes(index)"
                    @change="toggleSpecSelection(index)"
                    class="spec-checkbox"
                  />
                  <span class="spec-number">規格 {{ index + 1 }}</span>
                </div>
                <button
                  v-if="specifications.length > 1"
                  class="remove-btn"
                  @click="removeSpecification(index)"
                >
                  刪除
                </button>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>規格名稱</label>
                  <input
                    type="text"
                    v-model="spec.name"
                    placeholder="請輸入規格"
                  />
                </div>
                <div class="form-group">
                  <label>商品貨號</label>
                  <input
                    type="text"
                    v-model="spec.productCode"
                    placeholder="請輸入商品貨號"
                  />
                </div>

                <!-- 🟢 價格不能為負數 -->
                <div class="form-group">
                  <label>售價</label>
                  <input
                    type="number"
                    v-model.number="spec.price"
                    placeholder="請輸入售價"
                    min="0"
                    step="1"
                    @input="handlePriceInput(spec)"
                  />
                </div>

                <div v-if="canViewCostPrice" class="form-group">
                  <label>成本價格</label>
                  <input
                    type="number"
                    v-model.number="spec.costPrice"
                    placeholder="請輸入成本價格"
                    min="0"
                    step="1"
                  />
                </div>

                <div class="form-group">
                  <label>目前庫存</label>
                  <input
                    type="number"
                    v-model.number="spec.stock"
                    placeholder="請輸入庫存"
                    min="0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          v-if="isNewProductFlow"
          class="btn btn-secondary"
          @click="handleBack"
        >
          上一步
        </button>
        <button
          v-if="!isNewProductFlow"
          class="btn btn-cancel"
          @click="handleClose"
        >
          取消
        </button>
        <button class="btn btn-confirm" @click="handleConfirm">確認</button>
      </div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/components/formate.css"></style>

<script src="@/assets/js/components/formate.js"></script>
